// extracted by mini-css-extract-plugin
export default {"container":"MainMenuBar_container__2pRmV","inner-container":"MainMenuBar_inner-container__gLMZN","topSpacer":"MainMenuBar_topSpacer__wjMD9"};